import React from 'react';
import { useTranslation } from 'react-i18next';
import ThumbMiddleContent from '@wix/da-ds/pkg/thumbs/legos/ThumbMiddleContent';
import Hidden from '@wix/da-ds/pkg/Icons/Hidden';
import HoverOnly from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverOnly';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { useDeviationMatureFilter } from '../../../../../../utils/hooks/useDeviationMatureFilter';
import { BlockReasons } from '../../../../../../Moderation/redux/types';
/** placeholder for various block reasons, eg mature, antisocial, etc
 * TODO: if one day we properly redo mature and such, create more specific
 * components for each block reason
 */ const BlockedMiddleContent = ({ thumbHeight , className , deviation  })=>{
    const { t  } = useTranslation();
    const { displayReason  } = useDeviationMatureFilter(deviation);
    const isMatureBlock = [
        BlockReasons.MatureAge,
        BlockReasons.MatureFilter,
        BlockReasons.MatureLoggedOut,
        BlockReasons.StrictMatureAge
    ].includes(displayReason);
    const isNsfg = displayReason === BlockReasons.Nsfg;
    let isUnreasonablySmall = thumbHeight && thumbHeight < 150;
    let blockText = '';
    if (isMatureBlock) {
        blockText = '.mature';
        if (thumbHeight && thumbHeight < 180) {
            isUnreasonablySmall = true;
        }
    }
    if (isNsfg) {
        blockText = '.nsfg';
        if (thumbHeight && thumbHeight < 200) {
            isUnreasonablySmall = true;
        }
    }
    if (isUnreasonablySmall) {
        return /*#__PURE__*/ React.createElement(HoverOnly, {
            reverseHidden: true
        }, /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
            icon: /*#__PURE__*/ React.createElement(Hidden, {
                size: IconSize.LARGE,
                disableDefaultColors: true
            }),
            className: className
        }));
    }
    return /*#__PURE__*/ React.createElement(ThumbMiddleContent, {
        title: t(`deviation.overlay.blocked${blockText}`),
        subtitle: isNsfg && t('deviation.overlay.blocked.nsfg.subtitle'),
        className: className
    });
};
BlockedMiddleContent.displayName = 'BlockedMiddleContent';
export default BlockedMiddleContent;
